import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import Progress from '../components/Loader';
import EngineeringIcon from '@mui/icons-material/Engineering';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import ListItem from '@mui/material/ListItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getexpenses } from '../redux/expenses';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 550,
  Height: '100%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function BasicModal() {
  const dt = new Date();
  const time = dt.getHours() + ':' + dt.getMinutes() + ':' + dt.getSeconds();
  const day = dt.getUTCDate();
  const month = String(dt.getMonth() + 1).padStart(2, '0');
  const year = dt.getFullYear();
  const date = year + '-' + month + '-' + day;
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const [open, setOpen] = React.useState(false);
  const [agent_, setagent_] = React.useState('none');
  const [loading, setloading] = React.useState(false);
  const [gender, setgender] = React.useState('none');
  const [paymentimp, setpaymentimp] = React.useState('none');
  const [payment, setpayment] = React.useState('none');
  const [customer, setcustomer] = React.useState('none');
  const [productservice, setproductservice] = React.useState('none');
  const [position, setposition] = React.useState('none');
  const [cultivatingmethod, setcultivatingmethod] = React.useState('none');
  const [croptype, setcroptype] = React.useState('none');
  const [seed, setseed] = React.useState('none');
  const [fertilizer, setfertilizer] = React.useState('none');
  const [water, setwater] = React.useState('none');
  const [worker, setworker] = React.useState('none');
  // Snackbar state
  const [snackbar, setSnackbar] = React.useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const dispatch = useDispatch();
  const admin = useSelector((state) => state.admin);
  const farmer = useSelector((state) => state.farmer);
  const product = useSelector((state) => state.product);
  const staff = useSelector((state) => state.staff);
  const sales = useSelector((state) => state.sales);
  const agent = useSelector((state) => state.agent);
  const warehouse = useSelector((state) => state.warehouse);
  const service = useSelector((state) => state.service);
  const center = useSelector((state) => state.center);
  const commodity = useSelector((state) => state.commodity);
  const expenses = useSelector((state) => state.expenses);

  const [pv, setpv] = React.useState(
    'PV' + Math.floor(Math.random() * 900000 + 100000) + dt.getHours() + dt.getMinutes() + dt.getSeconds()
  );

  const Food = [
    { value: 'Cereals' },
    { value: 'Industrial crops' },
    { value: 'Legumes' },
    { value: 'Fruits' },
    { value: 'Vegetables' },
    { value: 'Starchy' },
    { value: 'tuber' },
    { value: 'root crops' },
  ];

  // Function to handle Snackbar close
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  // Function to clear form fields and reset state
  const clearForm = () => {
    const form = document.getElementById('expenses-form');
    if (form) {
      form.reset();
    }
    // Reset relevant state variables
    setagent_('none');
    setpayment('none');
    setpv('PV' + Math.floor(Math.random() * 900000 + 100000) + new Date().getHours() + new Date().getMinutes() + new Date().getSeconds()); // Regenerate pv
  };

  // Functions
  const addfarmer = () => {
    setloading(true);
    const doer = async () => {
      try {
        const response = await axios.post(
          'https://server.agrotraciserp.com/api/expenses/addexpenses/',
          {
            amount: document.getElementById('amount').value,
            requester: agent_,
            constcenter: document.getElementById('costcenter').value,
            date: document.getElementById('date').value,
            description: document.getElementById('description').value,
            id: document.getElementById('id').value,
            payment: payment,
            type: 'imprest',
            pv: pv,
          }
        );

        if (response.status === 200) {
          setloading(false);
          dispatch(
            getexpenses({
              data: response.data,
            })
          );
          setSnackbar({
            open: true,
            message: 'Imprest added successfully!',
            severity: 'success',
          });
          clearForm();
          handleClose();
        } else {
          setloading(false);
          setSnackbar({
            open: true,
            message: 'Failed to add imprest',
            severity: 'error',
          });
        }
      } catch (err) {
        console.log(err);
        setloading(false);
        setSnackbar({
          open: true,
          message: 'Error adding imprest',
          severity: 'error',
        });
      }
    };
    doer();
  };

  return (
    <div>
      <Button variant="outlined" startIcon={<EngineeringIcon />} onClick={handleOpen}>
        Add Expenses
      </Button>

      <Dialog
        fullWidth
        minWidth="sm"
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Add new Imprest
          <IconButton onClick={handleClose} style={{ float: 'right' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box
            component="form"
            id="expenses-form"
            sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
            noValidate
            autoComplete="off"
          >
            <FormControl style={{ width: '98%', marginTop: '15px', marginLeft: '8px' }}>
              <InputLabel id="demo-simple-select-label">Choose Agent</InputLabel>
              <Select
                required
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={agent_}
                label="Choose Agent"
                onChange={(e) => setagent_(e.target.value)}
              >
                <MenuItem value="none">Choose</MenuItem>
                {agent.map((i) => (
                  <MenuItem key={i.idnumber} value={i.idnumber}>
                    {i.surname + ' ' + i.othername + ' ' + i.lastname }
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              id="amount"
              required
              label="Amount"
              type="number"
              style={{ width: '98%' }}
              autoComplete="current-text"
              InputProps={{
                startAdornment: <InputAdornment position="start">GHC </InputAdornment>,
              }}
            />

            <TextField
              id="date"
              required
              label="Date"
              type="date"
              style={{ width: '98%', marginTop: '15px' }}
              autoComplete="current-text"
            />

            <TextField
              id="costcenter"
              required
              label="Cost Center"
              type="text"
              style={{ width: '98%', marginTop: '15px' }}
              autoComplete="current-text"
            />

            <TextField
              id="description"
              required
              label="Description"
              type="text"
              style={{ width: '98%', marginTop: '15px' }}
              autoComplete="current-text"
            />

            <FormControl style={{ width: '98%', marginTop: '15px', marginLeft: '8px' }}>
              <InputLabel id="demo-simple-select-label">Mode Of Payment</InputLabel>
              <Select
                required
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={payment}
                label="Mode Of Payment"
                onChange={(e) => setpayment(e.target.value)}
              >
                <MenuItem value="none">Choose</MenuItem>
                <MenuItem value="Momo">Momo</MenuItem>
                <MenuItem value="Cash">Cash</MenuItem>
                <MenuItem value="Cheque">Cheque</MenuItem>
              </Select>
            </FormControl>

            <TextField
              id="id"
              required
              label="Transaction Id / Cheque Number"
              type="text"
              style={{ width: '98%', marginTop: '15px' }}
              autoComplete="current-text"
            />
          </Box>
        </DialogContent>
        <Divider />
        <DialogActions>
          <div style={{ marginTop: 2, textAlign: 'center', width: '100%' }}>
            {loading ? (
              <Button variant="outlined" startIcon={<Progress />} disabled>
                Loading...
              </Button>
            ) : (
              <Button
                variant="outlined"
                startIcon={<EngineeringIcon />}
                size="large"
                onClick={addfarmer}
              >
                Submit New Imprest
              </Button>
            )}
          </div>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}